import en from './en';
import cn from './cn';

export default {
  en_US: en,
  zh_CN: cn,
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js